import template from './specialty.jade';
import { initializeHintClickTracking } from '../../../utils/hint-tracking';
import './specialty.styl';

export default angular
.module('cian.addForm.helperSpecialty', [])
.directive('cianAfHelperSpecialty', ['$timeout', 'categoryService', 'apiService', ($timeout, categoryService, apiService) => ({
    scope: {},
    require: ['cianAfHelperSpecialty', 'ngModel'],
    bindToController: {
        itemsForCategory: '=',
        tooltipDisable: '@',
        tooltipIsOpen: '=',
        cuiInvalid: '=',
        cuiRequired: '=',
    },
    link(scope, element, attrs, [ctrl, ngModelCtrl]) {
        element.attr('tabindex', '0');
        const elementNode = element[0];

        let isFocused = false;
        const processFocus = () => {
            isFocused = true;
        };
        const processBlur = () => {
            isFocused = false;
            $timeout(() => {
                if (!isFocused) {
                    ngModelCtrl.$touched = true;
                    elementNode.removeEventListener('focus', processFocus, true);
                    elementNode.removeEventListener('blur', processBlur, true);
                }
            }, 0);
        };

        elementNode.addEventListener('focus', processFocus, true);
        elementNode.addEventListener('blur', processBlur, true);

        const addTag = tag => {
            ngModelCtrl.$setViewValue([...ngModelCtrl.$viewValue, tag]);
        };

        scope.addRegularTag = tag => {
            if (!ngModelCtrl.$viewValue.find(item => item.id === tag.id)) {
                addTag({
                    type: 'regular',
                    ...tag,
                });
            }
        };

        scope.addTextTag = text => {
            if (!ngModelCtrl.$viewValue.find(item => item.rusName.toLowerCase() === text.toLowerCase())) {
                addTag({
                    type: 'text',
                    rusName: text,
                });
            }
        };

        scope.removeTag = tag => {
            ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue.filter(item => item !== tag));
        };

        const initTypes = (modelValue) => {
            if (!modelValue) {
                return [];
            }
            // specialties может прийти null от бекенда,
            // а destructuring assignment считает null значением и не применяет значение по умолчанию
            const { types = [] } = modelValue,
                specialties = modelValue.specialties || [];
            return types.reduce((res, tagId) => {
                const tag = specialties.find(item => item.engName === tagId);
                if (tag) {
                    res.push({
                        ...tag,
                        type: 'regular',
                    });
                }
                return res;
            }, []);
        };

        const initAdditionalTypes = (additionalTypes = []) => additionalTypes.reduce((res, name) => {
            res.push({
                rusName: name,
                type: 'text',
            });

            return res;
        }, []);

        ngModelCtrl.$formatters.push(modelValue => [
            ...initTypes(modelValue),
            ...initAdditionalTypes(modelValue && modelValue.additionalTypes),
        ]);

        ngModelCtrl.$parsers.push(viewValue => {
            const modelValue = {
                types: [],
                specialties: [],
                additionalTypes: [],
            };

            viewValue.reduce((model, item) => {
                if (item.type === 'text') {
                    model.additionalTypes.push(item.rusName);
                }
                if (item.type === 'regular') {
                    const { type, ...originalSpecialty } = item;
                    model.types.push(item.engName);
                    model.specialties.push(originalSpecialty);
                }
                return model;
            }, modelValue);

            return modelValue;
        });

        const getExcludedItems = () => (ngModelCtrl.$modelValue && ngModelCtrl.$modelValue.types && ngModelCtrl.$modelValue.types.length > 0) ? [...ngModelCtrl.$modelValue.types] : [];

        ngModelCtrl.$render = () => {
            ctrl.tags = ngModelCtrl.$viewValue;
            ctrl.isInvalid = ngModelCtrl.$invalid;
            ctrl.excludedItems = getExcludedItems();
        };

        ngModelCtrl.$viewChangeListeners.push(() => {
            ctrl.tags = ngModelCtrl.$viewValue;
            ctrl.isInvalid = ngModelCtrl.$invalid;
            ctrl.excludedItems = getExcludedItems();
        });

        ngModelCtrl.$isEmpty = viewValue => {
            return !viewValue || viewValue.length === 0;
        };

        // Это хак для очистки пришедшей модели с сервера
        // Запускаем ngModelCtrl.$parsers и чистим таким образом модель
        // При первом запуске выполняются $formatters, которые получают $modelValue и на основе этих данных создают $viewValue. $viewValue - не содержит мусора, но модель по прежнему содержит мусор. Я эмулирую событие изменения $viewValue, и дальше начинает работать $parsers которые парсят $viewValue и генерируют $modelValue, которая и является тем что мы видим в форме(ad)
        $timeout(function () {
            ngModelCtrl.$setViewValue(angular.copy(ngModelCtrl.$viewValue), 'input');
        }, 0);
    },
    controller: ['$scope', '$q', 'deviceService', 'analyticsService', function ($scope, $q, deviceService, analyticsService) {
        this.isMobile = deviceService.isMobile;
        this.addRegularTag = tag => $scope.addRegularTag(tag);
        this.addTextTag = text => $scope.addTextTag(text);
        this.removeTag = tag => $scope.removeTag(tag);

        this.items = window.addFormState.specialties;

        this.tooltipText = 'Вы можете выбрать несколько вариантов<br/>назначения помещения';
        this.unsubscribeHintListener = null;
        this.isHintTrackingInitialized = false;
        this.tooltipDisable = false;

        // откладвываем инициализацию hint'a, для того чтобы шаблон успел отрендерится
        setImmediate(() => {
          this.unsubscribeHintListener = initializeHintClickTracking(
            'speciality-hint',
            analyticsService.adAnalyticsCategory
          );
        });

        $scope.$on('$destroy', () => {
          if (this.unsubscribeHintListener) {
            this.unsubscribeHintListener();
          }
        });

        this.onChangeText = (text = '') => {
            return Promise.resolve(
                this.items.filter(item =>
                    item.rusName.toLowerCase().indexOf(text.toLowerCase()) !== -1
                )
            );
        };

        const titleByObjectType = {
            business: 'Сфера деятельности',
            freeAppointmentObject: 'Возможное назначение',
            shoppingArea: 'Возможное назначение',
            default: 'Специализация<br>помещения',
        };

        $scope.$watch(() => this.itemsForCategory, category => {
            if (!category) return;
            const { objectType } = categoryService.getInfoByCategory(category);
            this.title = titleByObjectType[objectType] || titleByObjectType.default;
        });
    }],
    controllerAs: 'helperSpecialty',
    template,
})])
.name;
